import { FileDownloadResponse } from "models/response/file-download-response";
import { slugify } from "./slugify";

// Gera um nome de arquivo amigável a partir de um texto livre (ex.: a descrição de um documento),
// preservando a extensão original do arquivo. Usado pra fazer o navegador baixar o PDF como
// "rreo-2026.pdf" em vez do nome físico gerado no upload (ex.: um GUID).
export const buildDownloadFileName = (description: string, sourceUrl: string): string => {
  const extensionMatch = sourceUrl.match(/\.([a-zA-Z0-9]{1,5})(?:$|[?#])/);
  const extension = extensionMatch ? extensionMatch[1].toLowerCase() : "pdf";

  const slug = slugify(description || "documento").slice(0, 80) || "documento";

  return `${slug}.${extension}`;
};

const base64ToBlob = (base64: string, contentType = ""): Blob => {
  const byteCharacters = atob(base64);
  const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: contentType });
};

export const downloadFile = (file: FileDownloadResponse): void => {
  const blob = base64ToBlob(file.source, file.contentType);
  const blobUrl = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = file.fileName;
  link.click();

  URL.revokeObjectURL(blobUrl);
};
